import React, { Component, PropTypes } from 'react';
import SimpleOverview from 'components/Widgets/SimpleOverview';
import {
  LinearProgress,
  List,
  ListItem,
  Toolbar,
  ToolbarTitle,
  ToolbarGroup,
  FlatButton,
  Dialog
} from 'material-ui';
import { InvitationActions, StudentActions } from 'actions';
import { mixin, RefluxMixin, Authorizer } from 'Util';
import ScrollableContainer from 'components/ScrollableContainer';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import Message from 'services/Message';
import { InvitationStore } from 'stores';
import * as StyleColors from 'components/Material/Styles/Colors';

import * as SvgIcons from 'components/Material/SvgIcons';

const { Colors } = StyleColors;

const colorLookup = {
  sent: Colors.green[500].material,
  bounced: Colors.red[500].material,
  rejected: Colors.red[500].material,
  error: Colors.red[500].material,
  unknown: Colors.grey[500].material
};

export default class InvitationDetail extends mixin(
  RefluxMixin,
  Authorizer,
  Component
) {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedCourse: {
        name: context.getIntlMessage('course.noSelected')
      },
      selectedGroup: { name: context.getIntlMessage('group.noSelected') }
    };
  }

  listenToActions() {
    this.listenToAction(InvitationActions.deleteComplete, () => {
      Message.info(this.context.getIntlMessage('invitation.removed'));
      this.closeDetail();
    });
    this.listenToAction(InvitationActions.resendComplete, () => {
      Message.info(this.context.getIntlMessage('invitation.resent'));
      this.closeDetail();
    });
  }

  confirmDelete() {
    this.refs.confirmDialog.show();
  }

  listenToStores() {
    this.listenToStore(InvitationStore);
  }

  componentDidMount() {
    InvitationActions.getInvitationEmailStatus(this.props.id);
  }

  onConfirm() {
    this.refs.removeDialog.dismiss();
    InvitationActions.delete(this.props.id);
    StudentActions.filter();
  }

  selectCourse(course) {
    this.setState({ selectedCourse: course });
  }

  selectGroup(group) {
    this.setState({ selectedGroup: group });
  }

  revokeAccess() {
    this.refs.removeDialog.show();
  }

  resend() {
    InvitationActions.resend(this.props.id);
  }

  closeDetail() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const { invitation } = this.props;
    const confirmActions = [
      <FlatButton
        key="ok"
        label={this.context.getIntlMessage('OK')}
        secondary
        className="full"
        onTouchTap={this.onConfirm.bind(this)}
      />
    ];

    const toolbar = (
      <Toolbar>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarTitle text={this.context.getIntlMessage('Invitation')} />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={1}>
          <ToolbarIconButton
            svgIcon={<SvgIcons.NavigationRefresh />}
            onTouchTap={this.resend.bind(this)}
          />
          <ToolbarIconButton
            svgIcon={<SvgIcons.ActionDelete />}
            onTouchTap={this.revokeAccess.bind(this)}
          />
          <ToolbarIconButton
            svgIcon={<SvgIcons.ContentClear />}
            onTouchTap={this.closeDetail.bind(this)}
          />
        </ToolbarGroup>
      </Toolbar>
    );

    let state;

    if (this.state.status.loading) {
      state = <LinearProgress mode="indeterminate" />;
    } else {
      state = (
        <span style={{ color: colorLookup[this.state.status.state] }}>
          {this.context.getIntlMessage(
            'emailStatus.' + this.state.status.state
          )}
        </span>
      );
    }

    return (
      <ScrollableContainer header={toolbar}>
        <List style={{ backgroundColor: '#FFFFFF' }}>
          <ListItem
            leftIcon={<SvgIcons.CommunicationEmail />}
            primaryText={invitation.email}
          />
        </List>
        <List style={{ backgroundColor: '#FFFFFF' }}>
          <ListItem leftIcon={<SvgIcons.ContentInbox />} primaryText={state} />
        </List>

        <SimpleOverview
          items={invitation.circles}
          readable="name"
          title={this.context.getIntlMessage('group.Groups')}
          onSelect={::this.selectGroup}
        />
        <SimpleOverview
          items={invitation.course}
          readable="name"
          title={this.context.getIntlMessage('course.Courses')}
          onSelect={::this.selectCourse}
        />
        <Dialog
          ref="removeDialog"
          title={this.context.getIntlMessage('invitation.remove')}
          actions={confirmActions}
          dismissOnClickAway
        />
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Invitation/Detail.js